import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useMemo } from 'react';
import { AGREEMENT_NAME_LABEL, VARIABLE_PRESENCE_PATTERN, isSystemVariable, normalizeVariableLabel, resolveSystemVariable, resolveVariablesInText } from '../TemplateVariables.utils';
export function useVariableResolution(variablesToResolve, context, templateVariableValues, businessDefaults) {
    return useMemo(()=>{
        const resolved = {};
        const defaultsByLabel = new Map();
        for (const d of businessDefaults){
            const key = normalizeVariableLabel(d.label.trim());
            if (!key) continue;
            if (!defaultsByLabel.has(key)) {
                defaultsByLabel.set(key, d.defaultValue);
            }
        }
        for (const label of variablesToResolve){
            const normalizedLabel = normalizeVariableLabel(label);
            if (isSystemVariable(label)) {
                resolved[normalizedLabel] = resolveSystemVariable(label, context);
            } else {
                const proposalValue = templateVariableValues[normalizedLabel];
                if (proposalValue !== undefined && proposalValue !== '') {
                    resolved[normalizedLabel] = proposalValue;
                } else {
                    const businessDefault = defaultsByLabel.get(normalizedLabel);
                    resolved[normalizedLabel] = businessDefault !== '' ? businessDefault : undefined;
                }
            }
        }
        const agreementNameKey = normalizeVariableLabel(AGREEMENT_NAME_LABEL);
        const rawAgreementName = resolved[agreementNameKey];
        if (rawAgreementName != null && VARIABLE_PRESENCE_PATTERN.test(rawAgreementName)) {
            const lookupExcludingSelf = _object_spread_props(_object_spread({}, resolved), {
                [agreementNameKey]: undefined
            });
            resolved[agreementNameKey] = resolveVariablesInText(rawAgreementName, lookupExcludingSelf);
        }
        return resolved;
    }, [
        variablesToResolve,
        context,
        templateVariableValues,
        businessDefaults
    ]);
}
